$(function(){

    /**
     * Order History Invoice Trigger
     */

    $('.js-trigger-invoice, .js-invoice-back').on('click', function(){
        //open modal & close the current active courses details
        const dataID = $(this).data('id');
        $('.js-history-target').toggle();
        $('.js-history-invoice[data-id="'+ dataID +'"]').toggleClass('hide');
    });



});